import { IconProps } from 'blaze-ui/icons/Types'
import { forwardRef } from 'react'

export const Facebook = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g id="Group 7313">
        <path
          id="Vector"
          d="M20 9.99919C19.9997 8.08806 19.4518 6.21703 18.4213 4.60761C17.3908 2.9982 15.9207 1.71778 14.1851 0.917954C12.4495 0.118127 10.5211 -0.167616 8.62821 0.0945507C6.73529 0.356718 4.95712 1.15582 3.50421 2.39725C2.0513 3.63867 0.984495 5.27045 0.430087 7.09938C-0.124321 8.92831 -0.143113 10.8778 0.375935 12.7171C0.894983 14.5564 1.93014 16.2084 3.35884 17.4776C4.78755 18.7468 6.54999 19.5801 8.4375 19.8787V12.8907H5.89875V9.99919H8.4375V7.79652C8.4375 5.28883 9.93 3.90498 12.215 3.90498C13.3088 3.90498 14.4525 4.09999 14.4525 4.09999V6.56143H13.1925C11.95 6.56143 11.5625 7.33274 11.5625 8.12405V9.99919H14.3363L13.8925 12.8907H11.5625V19.8787C13.9147 19.506 16.0567 18.3063 17.6034 16.4953C19.15 14.6843 19.9999 12.3809 20 9.99919Z"
          fill="#1877F2"
        />
        <path
          id="Vector_2"
          d="M14.3362 9.99933H11.5624V8.12419C11.5624 7.33288 11.9499 6.56157 13.1924 6.56157H14.4524V4.10014C14.4524 4.10014 13.3087 3.90512 12.2149 3.90512C9.92993 3.90512 8.43743 5.29023 8.43743 7.79667V9.99933H5.89868V12.8908H8.43743V19.8788C8.95433 19.9598 9.47674 20.0003 9.99993 20.0001C10.5231 20.0003 11.0455 19.9598 11.5624 19.8788V12.8908H13.8924"
          fill="white"
        />
      </g>
    </svg>
  )
})

export default Facebook
